import { commonRequest } from "../../../services/ApiCall";
import { Helpers } from "../../../services/Helpers";


export const materializeViewServices = {
    materializedViewList : async(data) =>{
        console.log("data",data);
        const queryParams = new URLSearchParams();

        // Basic pagination and sorting parameters
        queryParams.append('page', data.page + 1);
        queryParams.append('limit', data.limit);

        // Search parameters
        queryParams.append('searchKey', data.filters.searchKey || '');
        

        // Sorting parameters
        queryParams.append('sortBy', data.filters.sortBy);            
        queryParams.append('sortType', data.filters.sortType || 'desc');
        

        // Additional multi-column filters
        if (data.filters.filterOptions) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams",queryParams.toString());
        return await commonRequest("GET",  `${Helpers.URL()}/api/v2/admin/materialized-view/provider-service-view?${queryParams.toString()}`,{}, Helpers.token());

    },
    refreshMaterializedView: async() => {
        return await commonRequest("get", `${Helpers.URL()}/api/admin/setting/refreshView`, {}, Helpers.token());
    },
}